import { compose, withState, withPropsOnChange, withHandlers, renderNothing, branch } from 'recompose';
import { connect } from 'react-redux';
import { cloneDeep } from 'lodash';
import AdminCustomerDuplicateForm from '../components/AdminCustomerDuplicateForm';
import { fetchCustomer, mergeCustomers } from '../actions';
import { fetchUser } from '../../users/actions';

export default compose(
  branch(
    props => !props.user.customer,
    renderNothing
  ),
  connect(null, { fetchUser }),
  withState('customer', 'setCustomer', {}),
  withState('duplicates', 'setDuplicates', []),
  withState('duplicate', 'setDuplicate', null),
  withState('survivingCustomer', 'setSurvivingCustomer', null),
  withHandlers({
    cancel: props => () => {
      props.setDuplicate(null);
      props.setSurvivingCustomer(null);
    },
    fetch: props => customerId =>
    fetchCustomer(customerId).then(({ customer, duplicates }) => {
      props.setCustomer(customer);
      props.setDuplicates(duplicates);
    }),
  }),
  withHandlers({
    merge: props => () => {
      const duplicateCustomerId = props.customer.id === props.survivingCustomer.id ? props.duplicate.id : props.customer.id;
      return mergeCustomers(props.survivingCustomer.id, duplicateCustomerId).then((mergedCustomer) => {
        if (mergedCustomer.user.id !== props.user.id) {
          window.location = `/admin/customers/${mergedCustomer.user.id}`;
          return;
        }

        props.cancel();
        props.fetch(mergedCustomer.id);
      });
    },
    setSurviving: props => (survivingCustomerId) => {
      const customer = cloneDeep(props.customer.id === survivingCustomerId ? props.customer : props.duplicate);
      const duplicate = props.customer.id === survivingCustomerId ? props.duplicate : props.customer;
      const duplicateHasRegularUser = duplicate.user && duplicate.user.username.includes('@');
      const survivingDontHaveValidUser = !customer.user || !customer.user.username.includes('@');
      if (duplicateHasRegularUser && survivingDontHaveValidUser) {
        customer.user = cloneDeep(duplicate.user);
      }

      return props.setSurvivingCustomer({ ...customer });
    },
    setDuplicateCustomer: props => (duplicate) => {
      props.setDuplicate(duplicate);
      props.setSurvivingCustomer(null);
    },
  }), withPropsOnChange(['user'], (props) => {
    if (props.user.customer) {
      props.fetch(props.user.customer.id);
    }
  }),
)(AdminCustomerDuplicateForm);
